var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamIcn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.332,
    height: 20.999,
    viewBox: "0 0 23.332 20.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.666,14a2.868,2.868,0,0,0,2.917-2.8,2.919,2.919,0,0,0-5.833,0A2.868,2.868,0,0,0,11.666,14Zm0-8.4A5.737,5.737,0,0,1,17.5,11.2a5.737,5.737,0,0,1-5.833,5.6,5.737,5.737,0,0,1-5.833-5.6A5.737,5.737,0,0,1,11.666,5.6ZM20.416,21H2.917a2.939,2.939,0,0,1-2.042-.84A2.711,2.711,0,0,1,0,18.2V5.6A2.868,2.868,0,0,1,2.917,2.8H5.25L7.437.7A2.465,2.465,0,0,1,9.187,0h5.1a2.386,2.386,0,0,1,1.6.7l2.187,2.1h2.333a2.868,2.868,0,0,1,2.917,2.8V18.2A2.868,2.868,0,0,1,20.416,21Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamIcn);
export default __webpack_public_path__ + "static/media/cam_icn.8a925cee1b2be6583cea4d6265e73b55.svg";
export { ForwardRef as ReactComponent };